(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var widget = document.querySelector('.js-b2b-shipping');
    if (!widget) return;

    var cartForm = document.getElementById('cartform');
    var checkoutBtn = document.getElementById('checkout');
    var radios = widget.querySelectorAll('.js-b2b-radio');
    var carrierFields = widget.querySelector('.js-b2b-carrier-fields');
    var methodInput = widget.querySelector('.js-b2b-method-input');

    var carrierSelect = widget.querySelector('.js-b2b-carrier');
    var accountInput = widget.querySelector('.js-b2b-account');
    var zipInput = widget.querySelector('.js-b2b-zip');

    var errorSelection = widget.querySelector('.js-b2b-error-selection');
    var errorCarrier = widget.querySelector('.js-b2b-error-carrier');
    var errorAccount = widget.querySelector('.js-b2b-error-account');
    var errorZip = widget.querySelector('.js-b2b-error-zip');

    if (checkoutBtn) checkoutBtn.disabled = true;

    function getSelectedValue() {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return radios[i].value;
      }
      return null;
    }

    function showError(el) { if (el) el.style.display = ''; }
    function hideError(el) { if (el) el.style.display = 'none'; }

    function clearErrors() {
      hideError(errorSelection);
      hideError(errorCarrier);
      hideError(errorAccount);
      hideError(errorZip);
    }

    function validateOwnCarrier() {
      var valid = true;
      if (!carrierSelect.value) { showError(errorCarrier); valid = false; } else { hideError(errorCarrier); }
      if (!accountInput.value.trim()) { showError(errorAccount); valid = false; } else { hideError(errorAccount); }
      if (!zipInput.value.trim()) { showError(errorZip); valid = false; } else { hideError(errorZip); }
      return valid;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        clearErrors();
        methodInput.value = this.value;
        carrierFields.style.display = (this.value === 'own_carrier') ? '' : 'none';
        if (checkoutBtn) checkoutBtn.disabled = false;
      });
    });

    // Intercept form submit for validation only.
    // On success, the native form submission sends all attributes[...] inputs
    // to Shopify atomically — no AJAX needed.
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        clearErrors();
        var selected = getSelectedValue();

        if (!selected) {
          e.preventDefault();
          showError(errorSelection);
          return;
        }

        if (selected === 'own_carrier' && !validateOwnCarrier()) {
          e.preventDefault();
          return;
        }
        // Validation passed — let form submit naturally.
      });
    }
  });
})();
